
export const tutorials = {
  'backoffice.sidebarUser.sections.tutorials.items.theClubRegistration': 'Registrazione The Club',

  // Tutorials Index Page
  'tutorials.index.title': 'Centro di Apprendimento',
  'tutorials.index.subtitle': 'Guide passo dopo passo per aiutarti a iniziare',

  // Common
  'tutorials.common.downloadPdf': 'Scarica Guida PDF',
  'tutorials.common.pdfAlternative': 'Scarica la nostra guida completa in PDF',
  'tutorials.common.watchVideo': 'Guarda il Video Tutorial',
  'tutorials.common.pdfName': 'TheClub_Guida_Registrazione_IT.pdf',

  // Tutorial: Radex Markets Registration
  'tutorials.radexRegistration.title': 'Registrazione su Radex Markets Broker',
  'tutorials.radexRegistration.description': 'Scopri come aprire e configurare il tuo account su Radex Markets, il broker partner regolamentato di TheClub. Questa guida copre la creazione dell\'account, la presentazione dei documenti e la verifica dell\'identità.',
  'tutorials.radexRegistration.links.registration': 'Registrazione Radex Markets',

  // Tutorial: Wire Transfer
  'tutorials.wireTransfer.title': 'Finanziamento Account tramite Bonifico Bancario',
  'tutorials.wireTransfer.description': 'Una guida completa su come finanziare il tuo conto Radex Markets tramite bonifico bancario. Copre i dettagli bancari, i tempi di elaborazione e i passaggi di conferma.',
  'tutorials.wireTransfer.links.login': 'Accesso Radex Markets',

  // Tutorial: Card Funding
  'tutorials.cardFunding.title': 'Finanziamento Account tramite Carta di Credito/Debito',
  'tutorials.cardFunding.description': 'Una guida completa su come finanziare il tuo conto Radex Markets utilizzando una carta di credito o debito Visa o Mastercard. Veloce, sicuro e pronto in pochi minuti.',
  'tutorials.cardFunding.links.login': 'Accesso Radex Markets',

  // Tutorial: PAMM Registration
  'tutorials.pammRegistration.title': 'Registrazione all\'Account PAMM di TheClub',
  'tutorials.pammRegistration.description': 'Scopri come collegare il tuo conto Radex Markets al sistema PAMM di TheClub affinché i tuoi fondi siano gestiti dai nostri trader professionisti.',
  'tutorials.pammRegistration.links.institutional': 'PAMM Account Trading Istituzionale',
  'tutorials.pammRegistration.links.spartan': 'PAMM Account Spartan AI Trading',
  'tutorials.pammRegistration.links.login': 'Accesso PAMM Account',

  // Tutorial: TheClub Account Creation
  'tutorials.theclubAccount.title': 'Creazione dell\'Account TheClub',
  'tutorials.theclubAccount.description': 'Istruzioni passo dopo passo per creare il tuo account di abbonamento TheClub — dalla registrazione sulla piattaforma al completamento dell\'associazione con il tuo PAMM account.',
  'tutorials.theclubAccount.links.registration': 'Pagina di Registrazione TheClub',
  'tutorials.theclubAccount.links.registrationNote': 'Usa il link fornito dal tuo Sponsor',
  'tutorials.theclubAccount.links.website': 'Sito Web TheClub',
};
